import React from 'react';
import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Pages/Home';
import ServicePage from './components/Pages/ServicePage';
import AboutPage from './components/Pages/AboutPage';
import BlogPage from './components/Pages/BlogPage';
import BlogListPage from './components/Pages/BlogListPage';
import BlogDetailsPage from './components/Pages/BlogDetailsPage';
import PortfolioPage from './components/Pages/PortfolioPage';
import CaseStudyDetailsPage from './components/Pages/CaseStudyDetailsPage';
import TeamPage from './components/Pages/TeamPage';
import TeamDetailsPage from './components/Pages/TeamDetailsPage';
import ContactPage from './components/Pages/ContactPage';
import Layout2 from './components/Layout/Layout2';
import TechStartupPage from './components/Pages/TechStartupPage';
import ServiceDetailsPage from './components/Pages/ServiceDetailsPage';
import Shop from './components/Pages/Shop';
import ProductDetails from './components/Pages/Shop/ProductDetails';
import Cart from './components/Pages/Shop/Cart';
import Checkout from './components/Pages/Shop/Checkout';
import Success from './components/Pages/Shop/Success';
import Wishlist from './components/Pages/Shop/Wishlist';
import Layout3 from './components/Layout/Layout3';
import ErrorPage from './components/Pages/ErrorPage';
import InstallationServicesPage from './components/Pages/InstallationServicesPage';
import SiteAssessmentsEnergyAuditsPage from './components/Pages/SiteAssessmentsEnergyAuditsPage';
import FinancingOptionsPage from './components/Pages/FinancingOptionsPage';
import CustomQuotationsPage from './components/Pages/CustomQuotationsPage';
import AfterSalesSupportPage from './components/Pages/AfterSalesSupportPage';
import ProductSalesPage from './components/Pages/ProductSalesPage';
import Blog1 from './components/Pages/Blog-1';
import Blog2 from './components/Pages/Blog-2';
import Blog3 from './components/Pages/Blog-3';
import Blog4 from './components/Pages/Blog-4';
import Blog5 from './components/Pages/Blog-5';
import Blog6 from './components/Pages/Blog-6';
import Blog7 from './components/Pages/Blog-7';
import Blog8 from './components/Pages/Blog-8';
import Portfolio1 from './components/Pages/Portfolio-1';
import Portfolio2 from './components/Pages/Portfolio-2';
import Portfolio3 from './components/Pages/Portfolio-3';
import Portfolio4 from './components/Pages/Portfolio-4';
function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route path="about" element={<AboutPage />} />
        <Route path="service" element={<ServicePage />} />
        <Route path="service/installation-services" element={<InstallationServicesPage />} />
        <Route path="service/site-assessments-energy-audits" element={<SiteAssessmentsEnergyAuditsPage />} />
        <Route path="service/financing-options" element={<FinancingOptionsPage />} />
        <Route path="service/custom-quotations" element={<CustomQuotationsPage />} />
        <Route path="service/after-sales" element={<AfterSalesSupportPage />} />
        <Route path="service/product-sales" element={<ProductSalesPage />} />
        <Route
          path="service/:serviceDetailsId"
          element={<ServiceDetailsPage />}
        />
        <Route path="blog" element={<BlogPage />} />
        <Route path="blog/blog-1" element={<Blog1 />} />
        <Route path="blog/blog-2" element={<Blog2 />} />
        <Route path="blog/blog-3" element={<Blog3 />} />
        <Route path="blog/blog-4" element={<Blog4 />} />
        <Route path="blog/blog-5" element={<Blog5 />} />
        <Route path="blog/blog-6" element={<Blog6 />} />
        <Route path="blog/blog-7" element={<Blog7 />} />
        <Route path="blog/blog-8" element={<Blog8 />} />
        <Route path="blog-list" element={<BlogListPage />} />
        <Route path="blog/:blogDetailsId" element={<BlogDetailsPage />} />
        <Route path="portfolio" element={<PortfolioPage />} />
        <Route path="portfolio/portfolio-1" element={<Portfolio1 />} />
          <Route path="portfolio/portfolio-2" element={<Portfolio2 />} />
          <Route path="portfolio/portfolio-3" element={<Portfolio3 />} />
          <Route path="portfolio/portfolio-4" element={<Portfolio4 />} />
        <Route path="case-study-details" element={<CaseStudyDetailsPage />} />
        <Route path="team" element={<TeamPage />} />
        <Route path="team/:teamDetailsId" element={<TeamDetailsPage />} />
        <Route path="contact" element={<ContactPage />} />
      </Route>
      <Route path="/" element={<Layout2 />}>
        <Route index element={<Home />} />
        <Route path="tech-startup" element={<TechStartupPage />} />
      </Route>
      <Route path="/" element={<Layout3 />}>
        <Route path="shop" element={<Shop />} />
        <Route path="shop/:productId" element={<ProductDetails />} />
        <Route path="shop/cart" element={<Cart />} />
        <Route path="shop/checkout" element={<Checkout />} />
        <Route path="shop/success" element={<Success />} />
        <Route path="shop/wishlist" element={<Wishlist />} />
      </Route>
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default App;
